import { render } from "./createUser.vue?vue&type=template&id=680999da&scoped=true"
import script from "./createUserComponent.js?vue&type=script&lang=js"
export * from "./createUserComponent.js?vue&type=script&lang=js"

import "./createUser.vue?vue&type=style&index=0&id=680999da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680999da"]])

export default __exports__